<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="115"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-text [fieldId]="'incomingCallsThreshold'"></ziro-text>
      <ziro-text [fieldId]="'outgoingMinutesThreshold'"></ziro-text>
    </ziro-collapsible-section-card>

    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false" [isHighlightCard]="true">
      <h4 class="mb-2 strong">{{ 'tkey;admin.microsoft.calling_product_thresholds.try_out.label' | translate }}</h4>
      <div>
        {{ 'tkey;admin.microsoft.calling_product_thresholds.usage_example.label_1' | translate }}
        <ziro-text [fieldId]="'incomingCalls'"></ziro-text>
        {{ 'tkey;admin.microsoft.calling_product_thresholds.usage_example.label_2' | translate }}
        <ziro-text [fieldId]="'outgoingMinutes'"></ziro-text>
        {{ 'tkey;admin.microsoft.calling_product_thresholds.usage_example.label_3' | translate }}
      </div>
      <div>
        <h4 class="strong">
          {{ 'tkey;admin.microsoft.calling_product_thresholds.usage_example.calculated_plan.suggestion' | translate }}
          <span class="text-primary" data-automation="suggested-plan">
            {{ suggestedPlanType | translate }}
          </span>
        </h4>
        <p
          [innerHTML]="suggestedPlanDescription | escapeHtml"
          data-automation="suggested-plan-description"
          class="mb-0"
        ></p>
      </div>
    </ziro-collapsible-section-card>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
